import * as signalR from "@microsoft/signalr";
import {jobTypeCodes} from "@/enums/jobTypeCodes";

export default ({ app }, inject) => {
  const defaultAPI = 'http://localhost:50000/api/'
  const apiBaseUrl = app.$config.axios.browserBaseURL || defaultAPI
  const connection = new signalR.HubConnectionBuilder()
    .withUrl( `${apiBaseUrl}signalr`,{skipNegotiation: true,transport: signalR.HttpTransportType.WebSockets}) // The URL where your SignalR hub is hosted
    .configureLogging(signalR.LogLevel.Information)
    .build();

  connection.start().then(() => {
    console.log("Connection established");
    if (connection && connection.state === "Connected" && app.$auth?.user?.id) {
      try {
        connection.invoke("AddToGroupAsync", app.$auth.user.id)
        console.log("Joined group successfully");
      } catch (error) {
        console.error("Error joining group:", error);
      }
    } else {
      console.error("SignalR connection is not established");
    }

    connection.on("sendnotificationtouser", (user, message) => {
      if (message && message.data) {
        app.$toast.success(message.data.message)
        app.store.dispatch('common/notification/getNewNotificationCount');
      } else {
        console.error("SignalR message is missing!.");
        app.$toast.error("SignalR message is missing!.")

      }
    });

    connection.on("sendopenordernotificationtouser", async (user, message) => {
      if (message && message.data && message.data.orderId) {
        // it will be dynamic based on the order type and order id, for now, we are using a static path for demonstration
        const targetPath = `/services/custom-order/${message.data.orderId}`
        if (app.router.currentRoute.path !== targetPath) {
          const root = (app && app.$root) || (typeof window !== "undefined" && window.$nuxt)

          let orderTypeName = "custom order"

          switch (message.data.orderTypeCode) {
            case jobTypeCodes.CustomJobOrder:
              orderTypeName = "custom order"
              break;
            case jobTypeCodes.CustomPriceQuote:
              orderTypeName = "custom price quote"
              break;
            case jobTypeCodes.AppraisalJobOrder:
              orderTypeName = "appraisal order"
              break;
            case jobTypeCodes.AppraisalPriceQuote:
              orderTypeName = "appraisal price quote"
              break;
            default:
              orderTypeName = "custom order"
              break;
          }

          const itemTypeNames = Array.isArray(message.data.itemTypeNames)
            ? message.data.itemTypeNames.join(", ")
            : ""

          const confirmed = await root.$confirm(
            itemTypeNames ? `New ${orderTypeName} - ${itemTypeNames}` : `New ${orderTypeName}`,
            itemTypeNames
              ? `You have a new ${orderTypeName} (${itemTypeNames}). Do you want to open the order details?`
              : `You have a new ${orderTypeName}. Do you want to open the order details?`,
            { color: '#27333f' }
          )
          if (confirmed) {
            app.router.push(targetPath)
          }
        }
      } else {
        console.error("SignalR open order message is missing!.");
      }
    });
  }).catch(err => console.error(err));


  inject('connection', connection);
}
